
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1R9iT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9f4595f61353f675$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $9f4595f61353f675$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'stigande',
    'fabric.editor.headingLink.copied': 'Kopierad!',
    'fabric.editor.headingLink.copyAnchorLink': "Kopiera l\xe4nk till rubrik",
    'fabric.editor.headingLink.copyAriaLabel': 'Kopiera',
    'fabric.editor.headingLink.descSortingLabel': 'fallande',
    'fabric.editor.headingLink.failedToCopy': 'Kopiering misslyckades',
    'fabric.editor.headingLink.noneSortingLabel': 'Ingen',
    'fabric.editor.inlineComment.marker.end': "slut p\xe5 inlinekommentarer",
    'fabric.editor.inlineComment.marker.start': "start p\xe5 inlinekommentarer"
};

});


//# sourceMappingURL=sv.30dd8fc5.js.map
